import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import MarketDrawer from "pages/BasicTrade/components/MarketDrawer";
import TradeHead from "pages/BasicTrade/components/TradeHead";
import TradingViewChart from "pages/BasicTrade/components/TradeChartView/Components/TradingViewChart";
import { TradingViewHeader } from "pages/BasicTrade";

import { useSelector } from "react-redux";

function AdvancedTradeChart() {
  const navigate = useNavigate();
  const [showMarketDrawer, setShowMarketDrawer] = useState(false);

  const coinMarketDetails = useSelector(
    (state) => state.market.investmentMarket?.data
  );

  const tradeInsertForm = useSelector(
    (state) => state.trade?.tradeInsertForm?.data
  );

  const destinations = useSelector(
    (state) => state.market.marketLoggedInForm?.data?.lisCoinDestination
  );

  return (
    <>
      <TradingViewHeader>
        <TradeHead
          navigationPath="/advanced-trade"
          setShowMarketDrawer={setShowMarketDrawer}
          coinMarketDetails={coinMarketDetails}
          coinList={tradeInsertForm?.lisCoinPair}
          destinations={destinations}
        />
      </TradingViewHeader>

      <TradingViewChart
        height="380"
        symbol={coinMarketDetails?.coinSourceName}
      />

      <MarketDrawer
        onRowClick={(row) => {
          navigate(
            `/advanced-trade/${row.data.coinSourceId}/${row.data.coinDestinationId}`
          );

          setShowMarketDrawer(false);
        }}
        open={showMarketDrawer}
        onClose={() => setShowMarketDrawer(false)}
        destinations={destinations}
      />
    </>
  );
}

export default AdvancedTradeChart;
